import React, { ReactElement, useEffect, useRef, useState } from 'react';
import {
  Form, Table, Pagination, Button, Select,
  Row, Col, Skeleton, Tooltip, Checkbox, Radio, Popover, Empty,
} from 'antd';
import PageHeader from '../../../../shared/components/pageHeader/PageHeader';
import TagList from '../../../../shared/components/tags/tag';
import { useHistory } from 'react-router-dom';
import {
  actions,
  ADMISSION_TITLE, ALL,
  CLAIMS_LISTING,
  CLAIM_NUMBER_SEARCH_PLACEHOLDER,
  getDraftTableMapping,
  getInPatientTableMapping,
  INPATIENT_ACTIONS,
  PRIMARY_BUTTON_TYPE,
  renderDraftIPOptions,
  renderIPOptions,
  SEARCH_PLACEHOLDER,
  TABLE_SIZE_MIDDLE,
  treatmentDetail,
  QUERY_DRAFT_FLOW,
  DRAFTS_ACCESS_MESSAGE,
  NON_CONFIGURED_PAYERS_DRAFT_ERROR,
} from '../../../../shared/constants/crmConstants';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../../store';
import {
  updateSelectedDetail, setFilterAction, fetchInPatientList, fetchTagListCount,
  bulkUploadClaims, searchInPatientList, setSortingPreference, setPageIndex,
  clearSearchDetail, saveInPatientConfig, nextStatusAction, nextStatusFilterAction,
  setCountClicked, setUpdateCourierDetailClicked,
  setIsDraftBtnClicked,
  setSelectedItem,
  fetchTotalClaimCount,
  setCourierUpdated, resetBulkUploadSelectedClaims, setBulkUploadSelectedClaims,
  deleteKeyfromBulkUploadSelectedClaims, setCenterIdList, setIsEasyDischargeCase,
  setIsPreAuthView,
  setSearchDataVisible,
  setViewCounts,
  setIsInitiateSettelmentBtnClicked,
  setUpdateCourierDetailBtnClicked,
  setDisplayFilters,
  selectedGlobalSearch,
  setUpdateCourierDetailBtnClickedFlag,
  setIsUploadClaimReportModalOpen,
  setIsDownloadClaimsModalOpen,
  setTpaDeskSecondaryFilter,
  setTPANextStatus,
  setShowSelectedTpaSecondaryFilters,
  setIsDateChanged,
  setIsClaimDetailApiLoaded,
  updateDropdownSearchFilter,
  setTpaGlobalSearchClicked,
  setTpaGlobalSearch,
  setTpaGlobalSearchValue,
  resetInPatientFilters,
  setElapseTimeDropdown,
  setElapsedTimeColorConfig,
  setFollowUpDetails,
  setSelectedElapsedTimeRemarks,

} from '../../../../store/actions/inPatientAction';
import { setSideBarHeader } from '../../../../store/actions/leftSideBarAction';
import {
  base64UrlEncode, centeredNotification, canActivate} from '../../../../utils/utility';
import {
  authFeatureConstants, DEFAULT_TABLE_CONFIGS, getPrefixforRemark, GUTTOR_SPACE,
  INITIAL_INPATIENT_CASES_COUNT, INVENTROY_CONSTANTS, MAILBOX_PASSWORD_EXPIRED_ERROR,
  PATIENT_SIGNATURE_CONSTANTS,
  RPA_PAYER_NOT_CONFIGURED_ERR, TPA_BANNER_TEXT,
} from '../../../../shared/constants/commonConstants';
import {
  checkIfAnyTableSearchEnabled, concatenateValues, convertToISOStrings,
  customGTMEvent, displayViewText, filteredObjects, getIsPageNameDetail,
  getIsPageNameEdit, getIsPageNameEditDischarge, getIsPageNameNewAdmission,
  getIsPageNameReconsider, getTableBasedOnConfig, isEnableInitiateSettlementBtn,
  isValidStayLength,
  uploadStyledSignature,
} from '../service/crmUtils';
import { ApplicationDetailModel } from '../../../../store/models/applicationDetailModel';
import TableConfigurator from '../../../../shared/components/TableConfigurator/TableConfigurator';
import { FormInstance } from 'antd/lib/form';
import { FilterOutlined } from '@ant-design/icons';
import './floatLabel.less';
import FilterAutoComplete from '../../../../shared/components/FilterAutocomplete/FilterAutoComplete';
import {
  clearPayerLookUp,
  fetchInPatientInsurerList, fetchInpatientStatusList, fetchLookupMaster, setAllPayerClaimStatuses,
  setGrievanceStatuses,
  setLookUpValues,
  setPayerClaimStatuses, setRIPayerClaimStatuses,
} from '../../../../store/actions/lookUpAction';
import {
  fetchDraftList, lockUnlockOrDeleteDraft,
} from '../../../../store/actions/savedDraftAction';
import {
  getSelectedSearchType,
  setAdditionalAdmissionInfo, setAdmissionForm, setIsDraftSelected,
  setIsShowAdmissionForm, setNameAdharVerified, setPanField, setSelectedBeneficiary, setSelectedDraft, setUploadedFiles,
  updateDraftValue,
  updateModalFormValue, updatePackageSelection, setPLTMappedValue, setHospitalOtherRoomType, setsubmitDisabled,
  setSelectedOption, setPanNoVerified, setAdharVerified, setVoterIdVerified, setDlVerified, setPanVerified,
  setDraftFormValidated,
  setNonAvailableClassification,
  setSelectedDiscrepency,
  setBuddhimedSelectedFiles,
  setClassificationArray,
  setNonSelectedDiscrepency,
  setProbability,
  setSelectedMemberId,
  setMemberName,
  setMemberSearchId,
  setPercentageNameMatch,
  setGovtSchemeUrn,
  setHisSelectedFiles,
  setIsSuccessModalNewAdmission,
  setUpdatedLetters,
  setDateApplied,
  setSelectedDoctorList,
  setPatientSignature,
  setSelectedConsentOptionStyle,
  setPatientConsentProceedClicked,
  setSelectedConsentOptions,
  setConsentDateTime,
  updateDefaultTimeline,
  setIsArtemis,
} from '../../../../store/actions/newAdmissionAction';
import moment from 'moment';
import { changePayer } from '../../../../store/actions/payerListAction';
import { isCancelClicked, setClaimData, showClaimDetailData } from '../../../../store/actions/claimDetailsAction';
import TpaTaglist from '../../../../shared/components/tags/tpaTagList';
import InpatientListSubFilters from './InPatientSubFilters';
import TrackCourierModal from './TrackCourierModal';
import { getHospDetail, setUserAuthData } from '../../../../store/actions/authAction';
import ClaimCountHeader from '../../../../shared/components/tags/ClaimCountHeader';
import MultiselectDropdownCheckbox from '../../../../shared/components/MultiselectDropdown/MultiSelectDropdownCheckbox';
import { setHospitalPatientSearchDetails, setIsHISClaim, setPatientSearchDetail } from '../../../../store/actions/hospitalAction';
import { setSelectedPolicyDetail } from '../../../../store/actions/nhcxAction';
import { fetchPayerConfig } from '../../../../store/actions/mailBoxAction';
import { PayerInitialState } from '../../../../store/models/payerListModel';
import { Payer } from '../../../../shared/models/payer.model';
import { updateIsOnNotificationflow } from '../../../../store/actions/utilAction';
import InpatientNoData from './InPatientNoData';
import { ReactComponent as CourierIcon } from '../../../../assets/images/svg/Courier.svg';
import { ReactComponent as Cancel_Icon } from '../../../../assets/images/svg/CancelIcon.svg';
import BucketedTPA from '../../../../shared/components/tags/bucketedTPA';
import { ReactComponent as DownloadCtx } from '../../../../assets/images/svg/Download-Ctx.svg';
import { ReactComponent as UploadCtx } from '../../../../assets/images/svg/Upload-Ctx.svg';
import ApplicationDetail from '../../../../shared/services/applicationDetail.service';
import { MailboxType } from '../../../../store/models/mailBoxModel';
import GlobalSearch from '../../../../shared/components/tags/GlobalSearch';
import { isEmpty } from 'lodash';
import { FollowUpModal } from '../../../../shared/components/modal/FollowUpModal';
import { getDefaultTimeline } from '../../../../utils/dateTimeUtils';

const List = (props: any): ReactElement => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [claimForm] = Form.useForm();
  const [trackCourierForm] = Form.useForm();
  // const { chartHeader } = useSelector((state: RootState): any => state?.sideBarHeader);

  const mounted = useRef(false);
  const [inPatientData, setInPatientData] = useState([] as any);
  const [draftData, setDraftData] = useState([] as any);
  const { Option } = Select;
  const [inPatientDataCount, setInPatientDataCount] = useState(-1);
  const [totalClaimCount, setTotalCount] = useState([] as any);
  const [draftDataCount, setDraftDataCount] = useState(-1);
  const [inPatientTagDataCount, setInPatientTagDataCount] = useState([] as any);
  const [inPatientColumns, setInPatientColumns] = useState([] as any);
  const [inPatientColumnsPreAuthView, setInPatientColumnsPreAuthView] = useState([] as any);
  const [inPatientColumnsClaimView, setInPatientColumnsClaimView] = useState([] as any);
  const [draftColumns, setDraftColumns] = useState([] as any);
  const [isColumnFilter, setIsColumnFilter] = useState(false);
  const [isTblLoading, setIsTblLoading] = useState(false);
  const [tpaTagListData, setTpaTagListData] = useState<any>({});
  const [totalFilterCount, setTotalFilterCount] = useState<any>({});
  const [isShowTrackCourierModal, setIsShowTrackCourierModal] = useState<boolean>(false);
  const [disableInitiateSettlementBtn, setDisableInitiateSettlementBtn] = useState<boolean>(false);
  const [inPatientCasesDataCount, setInPatientCasesDataCount] = useState(INITIAL_INPATIENT_CASES_COUNT);
  const tableRef = useRef<HTMLDivElement | null>(null);

  const isDownloadClaimEnabled = ApplicationDetail.instance.getIsDownloadClaimEnabled();
  const {
    lookUp: { payerClaimStatuses = [], allInsurers = [], payerAllClaimStatuses = [] },
    util: { oldLocations = [] },
    savedDraft: { draftDeleteCounter },
  } = useSelector((state: RootState): any => state || {});
  const appDetail = useSelector((state: RootState): ApplicationDetailModel => state.applicationDetail);
  const {
    isNextStatus, tpaNextStatus, timeFilter, tpaSecondaryFilter, badRequestCount,
    isCountClicked, bulkUploadSelectedClaims, updateCourierDetailClicked,
    filterAction, isSearchClicked, pageIndex, filters, sortingKey,
    isDraftBtnClicked, isGlobalFilter, selectedItem, isPreAuthView,
    viewCounts, searchDataVisible, updateCourierDetailBtnClicked, displayFilters,
    updateCourierDetailBtnClickedFlag, isInitiateSettelmentBtnClicked,
    showSelectedTpaSecondaryFilters, isDateChanged, selectedDateDropdown, tpaGlobalSearch, selectedElapsedTimeRemarks,
  } = useSelector((state: RootState): any => state?.selectedInPatientDetail || {});
  const { allPayers } = useSelector((state: RootState): PayerInitialState => state.payerList);
  const { hospitalConfiguration: emailConfiguration = {} as any } =
    useSelector((state: RootState): MailboxType => state?.mailBox || {});
  const { passwordExpire } = emailConfiguration || {};
  claimForm.setFieldsValue(bulkUploadSelectedClaims);
  const [searchForm] = Form.useForm();
  const autoCompleteRef = React.createRef<any>();
  const [resetSelectedTag, setResetSelctedTag] = useState(false);
  const [isCountLoading, setIsCountLoading] = useState(false);
  const inPatientTableMapping = getInPatientTableMapping(canActivate(authFeatureConstants.NEW_ADMISSION_BEHALF_OF_HOSPITALS));
  const draftTableMapping = getDraftTableMapping(canActivate(authFeatureConstants.NEW_ADMISSION_BEHALF_OF_HOSPITALS));
  const [resetBtnType, setResetBtnType] = useState<any>('default');
  const groupProviders = appDetail.getGroupProviders();
  const isNewTpaDeskEnabled = appDetail.getIsNewTpaDeskEnabled();
  const isPreAuthClaimViewEnabled = appDetail?.getIsPreAuthClaimViewEnabled();
  const isNewTpaActiveForGroupProvider = appDetail.getIsNewTpaActiveForGroupProvider();
  const groupProvidersPresent = !isEmpty(groupProviders);
  const getScrollContainer = (): HTMLDivElement | null => {
    return tableRef.current?.querySelector('.ant-table-content') as HTMLDivElement;
  };
  const showAvailableMessages = (!isNewTpaDeskEnabled || tpaNextStatus !== TPA_BANNER_TEXT.DRAFT_PENDING);
  const selectedDateDropdownString = selectedDateDropdown?.toString();
  const newAdmissionWriteAccess: boolean = canActivate(authFeatureConstants.NEW_ADMISSION);
  const logOutClicked = useSelector(
    ({ hospital: { isLogOutClicked } }: any): any => isLogOutClicked,
  );
  const providerDetail = JSON.parse(localStorage.getItem('providerDetail') || '{}');

  useEffect((): any => {
    localStorage?.removeItem('claimDetailResponse');
    localStorage?.removeItem(INVENTROY_CONSTANTS.patient_signature);
    dispatch(setClaimData({}));
    dispatch(isCancelClicked(false));
    dispatch(setHospitalPatientSearchDetails([]));
    dispatch(setPatientSearchDetail([]));
    dispatch(showClaimDetailData(false));
    dispatch(setIsClaimDetailApiLoaded(false));
    dispatch(setSideBarHeader(ALL));
    dispatch(setFollowUpDetails({}));
    if (providerDetail?.providerId && logOutClicked === false) {
      dispatch(fetchPayerConfig(providerDetail?.providerId));
    }
    mounted.current = true;
    if (
      oldLocations[0] &&
      !getIsPageNameDetail(oldLocations[0]) &&
      !getIsPageNameEdit(oldLocations[0]) &&
      !getIsPageNameEditDischarge(oldLocations[0]) &&
      !getIsPageNameReconsider(oldLocations[0]) &&
      !getIsPageNameNewAdmission(oldLocations[0])
    ) {
      dispatch(setDateApplied(false));
      dispatch(clearSearchDetail());
      dispatch(setIsDateChanged(false));
      dispatch(nextStatusAction(false));
    }
    const payerClaimStatus = JSON.parse(localStorage.getItem('payerClaimStatuses') || '{}');
    const filteredStatusData = JSON.parse(localStorage.getItem(`${isPreAuthClaimViewEnabled ? isPreAuthView ? 'filteredStatusPreAuthView' : 'filteredStatusClaimView' : 'filteredStatus'}`) || '{}');
    dispatch(setAllPayerClaimStatuses(JSON.parse(localStorage.getItem('filteredStatus') || '{}')));
    const filteredStatusReimbursement = JSON.parse(localStorage.getItem('filteredStatusReimbursement') || '{}');
    const grievanceStatus = JSON.parse(localStorage.getItem('grievanceStatus') || '{}');
    if (payerClaimStatus?.length) {
        dispatch(setPayerClaimStatuses(filteredStatusData));
        dispatch(setRIPayerClaimStatuses(filteredStatusReimbursement));
        dispatch(setGrievanceStatuses(grievanceStatus));
    }
    if (!payerClaimStatus?.length || !payerClaimStatuses || payerClaimStatuses?.length === 0 && !payerClaimStatus?.length) {
      dispatch(fetchInpatientStatusList());
    }
    if (isEmpty(allInsurers) && !isEmpty(allPayers)) { // to prevent insurer call as there is no active payer
      dispatch(fetchInPatientInsurerList());
    }
    if (oldLocations[0] && (getIsPageNameDetail(oldLocations[0]) || getIsPageNameNewAdmission(oldLocations[0]))) {
      // preventing mulitple api calls
      reloadTagCount('isOldLocationPresent');
    }
    customGTMEvent({
      event: 'Visit the Claims Page',
    });
    return (): boolean => {
      return mounted.current = false;
    };
  }, []);

  useEffect((): any => {
    if (updateCourierDetailBtnClicked) {
      updateCourierStatusBtnClickHandler();
    } else {
      dispatch(setUpdateCourierDetailClicked(false));
    }
  }, [updateCourierDetailBtnClicked, updateCourierDetailBtnClickedFlag]);

  useEffect((): void => {

    const filteredStatusPreAuthView = JSON.parse(
      localStorage.getItem('filteredStatusPreAuthView') || '{}');
    const filteredStatusClaimView = JSON.parse(
      localStorage.getItem('filteredStatusClaimView') || '{}');
    const filteredStatus = JSON.parse(
      localStorage.getItem('filteredStatus') || '{}');
    if (
      isPreAuthClaimViewEnabled &&
      filteredStatusPreAuthView &&
      isPreAuthView
    ) {
      dispatch(setPayerClaimStatuses(filteredStatusPreAuthView));
    } else if (isPreAuthClaimViewEnabled &&
      filteredStatusPreAuthView &&
      !isPreAuthView) {
      dispatch(setPayerClaimStatuses(filteredStatusClaimView));
    } else {
      dispatch(setPayerClaimStatuses(filteredStatus));
    }
  }, [isPreAuthView]);

  useEffect((): void => {
    if (updateCourierDetailClicked) {
      dispatch(nextStatusAction(false));
    }
  }, [updateCourierDetailClicked]);

  useEffect((): any => {
    dispatch(setIsEasyDischargeCase(false));
    dispatch(setIsDateChanged(false));
    // Clearing lookup and payerlookup redux values to get updated values
    dispatch(setLookUpValues({
      pastHistory: [], proposedLineOfTreatment: [], diagnosisType: [], designation: [], relation: [],
      badTreatment: [], badDiagnosis: [], courierService: [],
    }));
    dispatch(clearPayerLookUp());
  }, []);

  useEffect((): any => {
    if (checkIfAnyTableSearchEnabled(filters, sortingKey)) {
      setIsColumnFilter(true);
    } else {
      setIsColumnFilter(false);
    }
  }, [filters, sortingKey, viewCounts]);

  useEffect((): void => {
    const providerId = filters['providerId'];
    dispatch(setCenterIdList(providerId));
    if (isCountClicked) {
      reloadTagCount();
    }
  }, [filters['providerId']]);

  useEffect((): any => {
    if (tpaGlobalSearch?.value) {
      dispatch(setTpaGlobalSearchClicked(true));
    }
    setLoaderStateValue();
   if ((((timeFilter && (timeFilter && tpaNextStatus !== 'DRAFTCLAIM' && tpaNextStatus !== 'PREAUTHDRAFTS' && tpaNextStatus !== 'CLAIMVIEWDRAFTS')
    ) || !isDraftBtnClicked) && logOutClicked === false) && (badRequestCount < 2) && (!isDateChanged)) {
      setIsTblLoading(true);
      dispatch(fetchInPatientList({
        getInPatientList,
      }));
      if (process.env.REACT_APP_IS_TPA_CLAIM_COUNT_FILTER === 'true' && (badRequestCount < 2)) {
        dispatch(fetchTotalClaimCount({
          getTotalCountList,
        }));
      }
    } else if ((timeFilter || isDraftBtnClicked) && !logOutClicked) {
      setIsTblLoading(true);
      fetchDraftData();
    }
    setDisableInitiateSettlementBtn(isEnableInitiateSettlementBtn(tpaNextStatus));
  }, [timeFilter, tpaNextStatus, isSearchClicked, selectedItem, logOutClicked, badRequestCount, isPreAuthView, selectedDateDropdownString]);

  useEffect((): any => {
    if (isDraftBtnClicked && draftDeleteCounter > 0) {
      fetchDraftData();
    }
  }, [draftDeleteCounter]);

  useEffect((): void => {
    if (!isDateChanged) {
      return;
    }
    dispatch(setPageIndex(1));
    dispatch(
      fetchTagListCount({
        getTagListCount,
        getTpaTagListCount,
        getTagFilterCount,
      }),
    );

    if (tpaNextStatus === TPA_BANNER_TEXT.DRAFT_PENDING) {
      fetchDraftData();
    } else {
      dispatch(fetchInPatientList({ getInPatientList }));
    }
  }, [isDateChanged]);

  useEffect((): any => {
    const isFiltersEmpty =
      filters &&
      Object?.keys(filters)?.length === 0 ||
      Object?.values(filters)?.every(
        (value: any): any =>
          value === '' ||
          (Array?.isArray(value) &&
            value?.every((item: any): any => item === '')),
      );
    const dateFilter = selectedDateDropdown;
    const isDisplayFiltersEmpty =
      displayFilters && Object?.keys(filters)?.length === 0;
    const areFiltersValuesEmpty =
      filters &&
      Object?.values(filters)?.every((value: any): any => value === '');
    if (
     ( isPreAuthClaimViewEnabled &&
      !isFiltersEmpty &&
      !isTblLoading &&
      isSearchClicked > 0 &&
      !isDisplayFiltersEmpty &&
      !areFiltersValuesEmpty) || (isNewTpaDeskEnabled) // to show the message all the time if new Tpa is enabled
    ) {
      dispatch(setSearchDataVisible(true));
      isNewTpaDeskEnabled ? dispatch(setDisplayFilters({ dateFilter, ...filters })) :
      dispatch(setDisplayFilters(filters)); // updating the date filters in the display filters
    } else {
      dispatch(setSearchDataVisible(false));
    }
  }, [isSearchClicked, selectedDateDropdown, selectedElapsedTimeRemarks,
     isNewTpaActiveForGroupProvider]); // to change the inpatient message

  useEffect((): any => {
    let checkBoxColumn: any = [];
    const filteredDraftTable = getTableBasedOnConfig(isPreAuthClaimViewEnabled // setting the Draft columns on viewing Drafts
      ? isPreAuthView ? appDetail?.getIPPreAuthViewConfig() : appDetail?.getIPClaimViewConfig() :
      appDetail?.getIPConfig(), draftTableMapping);
    if (updateCourierDetailClicked) {
      claimForm.resetFields(); // resetting fields to uncheck previously selected Checkboxes
      if (Object.keys(bulkUploadSelectedClaims).length > 0) {
        const selectedClaimCount =
          Object.keys(bulkUploadSelectedClaims)
            ?.filter(
              (k: any): any =>
                bulkUploadSelectedClaims[k],
            ) || [];
        checkBoxColumn = [getCheckBoxColumn(selectedClaimCount?.length)];
      } else {
        checkBoxColumn = [getCheckBoxColumn(0)];
      }
    }

    const filteredTable = getTableBasedOnConfig(appDetail.getIPConfig(), inPatientTableMapping);
    setInPatientColumns(
      [
        ...checkBoxColumn,
        ...filteredTable,
        {
          key: 'action',
          render: renderIPOptions,
        },
      ]);
    const filteredTablePreAuthView = getTableBasedOnConfig(appDetail?.getIPPreAuthViewConfig(), inPatientTableMapping);
    setInPatientColumnsPreAuthView(
      [
        ...checkBoxColumn,
        ...filteredTablePreAuthView,
        {
          key: 'action',
          render: renderIPOptions,
        },
      ]);
    const filteredTableClaimView = getTableBasedOnConfig(appDetail?.getIPClaimViewConfig(), inPatientTableMapping);

    setInPatientColumnsClaimView(
      [
        ...checkBoxColumn,
        ...filteredTableClaimView,
      ]);
    setDraftColumns(
      [...filteredDraftTable,
      {
        key: 'action',
        render: renderDraftIPOptions,
      },
      ]);
  }, [appDetail, updateCourierDetailClicked, bulkUploadSelectedClaims, isPreAuthView]);

  useEffect((): any => {
    if (logOutClicked === false) {
      dispatch(fetchTagListCount({
        getTagListCount, getTpaTagListCount, getTagFilterCount,
      }));
    }
  }, [draftDeleteCounter, logOutClicked, isPreAuthView, selectedDateDropdownString]);

  useEffect((): any => {
    setResetBtnType(
      (
        isNextStatus || isColumnFilter || isGlobalFilter || filterAction !== ALL ||
        tpaNextStatus || timeFilter || tpaSecondaryFilter
      ) ? 'primary' : 'default',
    );
  }, [isColumnFilter, isNextStatus, filterAction, isGlobalFilter, tpaNextStatus, timeFilter, tpaSecondaryFilter]);

  const setLoaderStateValue = (): void => {
    setInPatientDataCount(-1);
    setInPatientCasesDataCount(INITIAL_INPATIENT_CASES_COUNT);
    setInPatientData(null);
    if (draftDataCount > 0) {
      setDraftDataCount(-1);
    }
    setDraftData(null);
  };
  const pageChange = (pageNumber: any): any => {
    if (tpaGlobalSearch?.value) {
      dispatch(setTpaGlobalSearchClicked(true));
    }
    dispatch(setPageIndex(pageNumber));
    dispatch(searchInPatientList());
  };

  const handleisPreAuthViewClick = (view: boolean): any => {
    if (isPreAuthView !== view) {
      if (!isPreAuthView) {
        customGTMEvent({
          event: 'Pre-Auth View toggle clicked',
        });
      } else {
        customGTMEvent({
          event: 'Claims View toggle clicked',
        });
      }
      dispatch(clearSearchDetail());
      if (isNewTpaDeskEnabled && isPreAuthClaimViewEnabled) {
        dispatch(setTPANextStatus(''));
        dispatch(setTpaDeskSecondaryFilter([]));
      }
      dispatch(setIsPreAuthView(view));
      searchForm.setFieldsValue({ searchValue: '' });
    }
  };

  const downloadAndUploadComponent = (): any => (
    <>
      <Col className="flex flex-element justify-center align-center downloadctxNewTpaDashBoard pl-0">
        <Popover
          content={
            <span className="inpatient_tooltip_header">
              {TPA_BANNER_TEXT.UPLOAD_CLAIM_TOOL_TIP_TITLE}
            </span>
          }
          placement="bottom"
        >
          <UploadCtx
            className="mouse-pointer"
            onClick={(): any => {
              dispatch(setIsUploadClaimReportModalOpen(true));
            }}
          />
        </Popover>
      </Col>
      <Col className="flex flex-element justify-center align-center ">
        <Popover
          content={
            <span className="inpatient_tooltip_header">
              {TPA_BANNER_TEXT.DOWNLOAD_OPEN_CLAIM_TOOL_TIP_TITLE}
            </span>
          }
          placement="bottom"
        >
          <DownloadCtx
            className="mouse-pointer"
            onClick={(): any => {
              dispatch(setIsDownloadClaimsModalOpen(true));
            }}
          />
        </Popover>
      </Col>
    </>
  );

  const changeAction = (selectedActionValue: any): void => {
    setLoaderStateValue();
    if (!selectedActionValue) {
      selectedActionValue = ALL;
    }
    dispatch(setFilterAction(selectedActionValue));
    dispatch(setPageIndex(1));
    dispatch(setSideBarHeader(selectedActionValue));
    dispatch(searchInPatientList());
    dispatch(nextStatusAction(false));
  };
  const changeNextFilterAction = (selectedActionValue: any): void => {
    setLoaderStateValue();
    if (!selectedActionValue) {
      selectedActionValue = ALL;
    }
    dispatch(nextStatusFilterAction(selectedActionValue));
    dispatch(setPageIndex(1));
    dispatch(setSideBarHeader(selectedActionValue));
    dispatch(searchInPatientList());
    dispatch(fetchTagListCount({ getTagListCount }));
  };

  const handlePrimaryFilterClick = (): any => {
    dispatch(setSearchDataVisible(false));
    dispatch(setDisplayFilters({}));
    setLoaderStateValue();
    dispatch(setPageIndex(1));
    dispatch(searchInPatientList());
  };

  const getTagListCount = (data: any): void => {
    setIsCountLoading(false);
    const { actionClaimCount, isSuccess, errors = [] } = data || {};
    if (isSuccess && mounted.current) {
      setInPatientTagDataCount(actionClaimCount);
    } else {
      setInPatientTagDataCount([]);
      centeredNotification(errors.join(',\n'));
    }
  };
  const getInPatientList = (data: any): void => {
  const { claimDetails, preAuthViewClaimCount, claimViewClaimCount, tpaDeskSecondaryFilter, elapseTimerDropdown,
   count, elapsedTimerColor, totalSecondaryBucketCount, isSuccess, errors = [] } = data;
    if (tpaDeskSecondaryFilter !== null) {
      dispatch(setShowSelectedTpaSecondaryFilters(tpaDeskSecondaryFilter));
    }
    if (isSuccess && mounted.current && claimDetails !== null) {
      claimDetails?.map((detail: any, index: number): void => {
        detail.key = index;
      });
      setInPatientData(claimDetails);
      dispatch(setViewCounts({ 'preAuthViewClaimCount': preAuthViewClaimCount, 'claimViewClaimCount': claimViewClaimCount }));
      dispatch(setElapseTimeDropdown(elapseTimerDropdown));
      dispatch(setElapsedTimeColorConfig(elapsedTimerColor));
      setInPatientDataCount(count);
    } else {
      setInPatientData([]);
      setInPatientDataCount(count);
      if (mounted.current) {
        centeredNotification(errors.join(',\n'));
      }
    }
    setInPatientCasesDataCount({'claimsCount': count || 0, 'secondaryClaimsCount': totalSecondaryBucketCount || 0});
    dispatch(setIsDateChanged(false));
    setIsTblLoading(false);
  };
  const getTotalCountList = (data: any): void => {
    const { claimCounts, isSuccess, errors = [] } = data;
    if (isSuccess && mounted.current) {
      setTotalCount(claimCounts);
    } else {
      centeredNotification(errors.join(',\n'));
    }
  };
  const handleSearchNavigation = (): void => {
    if (isPreAuthClaimViewEnabled && isNewTpaDeskEnabled) {
      dispatch(setTPANextStatus(''));
      delete filters.elapsedTime; // deleting the elapsed filter from the filters object onchange of view
      dispatch(setSelectedElapsedTimeRemarks([])); // to clear selected elapsed time remarks
      dispatch(setTpaDeskSecondaryFilter([]));
      dispatch(setShowSelectedTpaSecondaryFilters([]));
    }
    dispatch(setPageIndex(1));
    searchForm.setFieldsValue({ searchValue: '' });
    dispatch(selectedGlobalSearch(''));
    dispatch(setIsPreAuthView(!isPreAuthView));
    dispatch(resetBulkUploadSelectedClaims());
    dispatch(setUpdateCourierDetailBtnClicked(false));
    dispatch(setIsInitiateSettelmentBtnClicked(false));
    if (tpaGlobalSearch?.value) {
      dispatch(setTpaGlobalSearchClicked(true));
    }
    if (isPreAuthView) {
      customGTMEvent({
        event: 'Clicked on the Navigation Link in Pre Auth View',
      });
    } else {
      customGTMEvent({
        event: 'Clicked on the Navigation Link in Claims View',
      });
    }
  };
  const fetchDraftData = (): void => {
    setIsTblLoading(true);
    dispatch(fetchDraftList({
      getDraftList,
    }));
    dispatch(setIsDateChanged(false));
  };
  const clearInpatientDataAndSetLoader = (): void => {
    setInPatientData([]);
    setIsTblLoading(true);
  };
  const getDraftList = (data: any): void => {
    const {
      draftClaimDetails = [], count,
      isSuccess, errors = [],
      tpaDeskSecondaryFilter, totalSecondaryBucketCount,
    } = data;
    if (tpaDeskSecondaryFilter) {
      dispatch(setShowSelectedTpaSecondaryFilters(tpaDeskSecondaryFilter));
    }
    if (isSuccess && mounted.current) {
      draftClaimDetails.map((detail: any, index: number): void => {
        detail.key = index;
      });
      setDraftData(draftClaimDetails);
      setDraftDataCount(count);
      dispatch(setViewCounts({ 'preAuthViewClaimCount': count, 'claimViewClaimCount': count }));
    } else {
      setDraftData([]);
      setDraftDataCount(count);
      centeredNotification(errors.join(',\n'));
    }
    setInPatientCasesDataCount({'claimsCount': count || 0, 'secondaryClaimsCount': totalSecondaryBucketCount || 0});
    setIsTblLoading(false);
  };
  const handelCourierBtn = (): void => {
    clearInpatientDataAndSetLoader();
    dispatch(setUpdateCourierDetailBtnClicked(true));
    dispatch(setUpdateCourierDetailBtnClickedFlag(!updateCourierDetailBtnClickedFlag));
  };
  const handelCourierCloseBtn = (): void => {
    clearInpatientDataAndSetLoader();
    dispatch(setUpdateCourierDetailBtnClicked(false));
    dispatch(setCourierUpdated(false));
    dispatch(resetBulkUploadSelectedClaims());
    dispatch(fetchInPatientList({
      getInPatientList,
    }));
  };
  const getHospFailure = (errMsg: string): any => {
    centeredNotification(errMsg);
  };

  const getHospSuccess = (result: any): void => {
    dispatch(setUserAuthData(result));
  };

  const handleGlobalSearchClick = (selectedKey: string, searchText: string): void => {
    customGTMEvent({
      event: 'Global Search Clicked',
      'searchText': searchText,
    });
    const searchObject = {[selectedKey]: searchText};
    dispatch(setPageIndex(1));
    dispatch(setTPANextStatus(''));
    dispatch(setTpaDeskSecondaryFilter([]));
    dispatch(resetInPatientFilters());
    dispatch(setTpaGlobalSearchClicked(true));
    dispatch(setTpaGlobalSearch({ key: selectedKey, value: searchText }));
    dispatch(setTpaGlobalSearchValue(searchText));
    dispatch(updateDropdownSearchFilter(searchObject));
    dispatch(searchInPatientList());
  };

  const rowClick = async (event: any, record: any, index: any): Promise<void> => {
    if (record?.statusName === 'Pre Auth Query') {
      dispatch(updateIsOnNotificationflow(false));
    }
    if (isDraftBtnClicked) {
      if (!newAdmissionWriteAccess) {
        centeredNotification(DRAFTS_ACCESS_MESSAGE, 'info');
        return;
      }
      customGTMEvent({
        event: 'Draft Submission: Select a draft',
        statusName: record?.statusName,
      });
      if (record.providerId && Array.isArray(groupProviders) && groupProvidersPresent) {
        const hospId = [];
        hospId?.push(record.providerId);
        await dispatch(getHospDetail(hospId, (result: any): void => getHospSuccess(result), getHospFailure));
      }
      const payerId = `${record?.payerId}${record?.productCode || ''}`;
      const isPayerConfigured = allPayers.find((ele: Payer): boolean => {
        return ele?.uniqueIdentifier === payerId;
      });
      const { isOnMailPayer, isRpaPayer } = isPayerConfigured || {};
      if (isEmpty(allPayers)) { // to notify user that draft cannot be opened as there is no payer active for the provider
        centeredNotification(NON_CONFIGURED_PAYERS_DRAFT_ERROR, 'info');
      } else if (!isPayerConfigured) {
        centeredNotification(RPA_PAYER_NOT_CONFIGURED_ERR);
      } else if ((isOnMailPayer || isRpaPayer) && passwordExpire) {
        centeredNotification(MAILBOX_PASSWORD_EXPIRED_ERROR);
      } else {
        setTimeout((): any => {
          const { draftId, islocked = false, lockedBy } = record;
          if (!islocked || lockedBy === Number(appDetail.getUserId())) {
            const parsedDraftData = record?.rawDraft?.length > 0 ? JSON.parse(record?.rawDraft) : {};
            const {
              newFormValue,
              payer,
              uploadedFiles,
              selectedBeneficiaryDetail,
              selectedPackage,
              modalFormValue = {},
              additionalAdmissionInfo,
              claimDetails,
              panCardField,
              submitDisabled,
              panVerified,
              selectedPatientDetail,
              selectedPolicyDetail,
              memberIdEntered,
              memberSearchId,
              percentageNameMatch,
              govtSchemeUrn,
              isHISClaim,
              selectedHISFiles,
              hospitalSearchPatientDetails,
              hospitalOtherRoomType,
              nonAvailableClassification,
              selectedDiscrepency,
              selectedFiles,
              classificationArray,
              nonSelectedDiscrepency,
              showProbability,
              updatedVisibleLetters,
              selectedDoctorList,
              consentOptionStyle,
              patientConsentProceedClicked,
              consentOption,
              consentDateTime,
              patientSignature,
              isArtemis,
            } = parsedDraftData;
            const { providerId } = record;
            const {
              payerClaimNo, hospActionId, payerActualId,
              productCode, isDischargeContestCTA,
            } = claimDetails;
            const isCancel = false;
            const uniquePayerId = `${payerActualId}${productCode || ''}`;
            const { dateOfBirth, fullName } = newFormValue?.customerDetail || {};
            const { dateOfAdmission, dateOfDischarge, dateOfInjury, deliveryDate, dateOfDiagnosis,
              vaccinationDate, dateOfCommencement, dobOfChild, lmp, dateOfExpiry,
              dateOfSurgery, stayLength } = newFormValue[treatmentDetail] || {};
            const isQueryType = QUERY_DRAFT_FLOW?.some((keyword: any): any => parsedDraftData?.draftKey?.includes(keyword));
            const fileUploadRemarksKey = getPrefixforRemark(isDischargeContestCTA);
            const patientSignGuid = patientSignature?.[0]?.response?.fileUploadDetails?.[0]?.fileGuid;
            if (consentOption === PATIENT_SIGNATURE_CONSTANTS.PATIENT_SIGNATURE_OPTIONS[0]) {
              const patientSign = { guid: patientSignGuid, modifiedOn: patientSignature?.[0]?.uploadedOn };
              localStorage?.setItem(INVENTROY_CONSTANTS.patient_signature, JSON?.stringify(patientSign));
            }
            if (dateOfAdmission) {
              newFormValue[treatmentDetail].dateOfAdmission = moment(dateOfAdmission);
              modalFormValue.dateOfAdmission = moment(dateOfAdmission);
            }
            if (dateOfDischarge) {
              newFormValue[treatmentDetail].dateOfDischarge = moment(dateOfDischarge);
              modalFormValue.dateOfDischarge = moment(dateOfDischarge);
            }
            if (isValidStayLength(stayLength)) {
              const stayLengthISO = convertToISOStrings(stayLength);
              newFormValue[treatmentDetail].stayLength = stayLengthISO;
              modalFormValue.stayLength = stayLengthISO;
            }
            if (dateOfDiagnosis) {
              newFormValue[treatmentDetail].dateOfDiagnosis = moment(dateOfDiagnosis);
              modalFormValue.dateOfDiagnosis = moment(dateOfDiagnosis);
            }
            if (dateOfInjury) {
              newFormValue[treatmentDetail].dateOfInjury = moment(dateOfInjury);
            }
            if (deliveryDate) {
              newFormValue[treatmentDetail].deliveryDate = moment(deliveryDate);
            }
            if (dateOfBirth) {
              newFormValue.customerDetail.dateOfBirth = moment(dateOfBirth);
            }
            if (vaccinationDate) {
              newFormValue[treatmentDetail].vaccinationDate = moment(vaccinationDate);
              modalFormValue.vaccinationDate = moment(vaccinationDate);
            }
            if (dateOfCommencement) {
              newFormValue[treatmentDetail].dateOfCommencement = moment(dateOfCommencement);
              modalFormValue.dateOfCommencement = moment(dateOfCommencement);
            }
            if (dobOfChild) {
              newFormValue[treatmentDetail].dobOfChild = moment(dobOfChild);
              modalFormValue.dobOfChild = moment(dobOfChild);
            }
            if (lmp) {
              newFormValue[treatmentDetail].lmp = moment(lmp);
              modalFormValue.lmp = moment(lmp);
            }
            if (dateOfExpiry) {
              newFormValue[treatmentDetail].dateOfExpiry = moment(dateOfExpiry);
              modalFormValue.dateOfExpiry = moment(dateOfExpiry);
            }
            if (dateOfSurgery) {
              newFormValue[treatmentDetail].dateOfSurgery = moment(dateOfSurgery);
              modalFormValue.dateOfSurgery = moment(dateOfSurgery);
            }
            if (selectedPolicyDetail) {
              dispatch(setSelectedPolicyDetail(selectedPolicyDetail));
            }
            newFormValue.customerDetail.hospitalCenter = providerId;
            newFormValue.customerDetail.payerId = `${payer?.value}`;
            dispatch(updateDraftValue(parsedDraftData?.draftKey));
            dispatch(setClaimData(claimDetails));
            dispatch(changePayer(payer));
            dispatch(setIsDraftSelected(true));
            dispatch(setSelectedDraft(record));
            dispatch(setSelectedOption(parsedDraftData?.selectedOption));
            dispatch(setPanVerified(panVerified));
            dispatch(setNameAdharVerified(parsedDraftData?.nameMatch));
            const verified = parsedDraftData?.selectedOption === 'PAN NO.' ?
              setPanNoVerified : parsedDraftData?.selectedOption === 'AADHAR ID' ?
                setAdharVerified : parsedDraftData?.selectedOption === 'Driving License' ?
                  setDlVerified : setVoterIdVerified;
            dispatch(verified(parsedDraftData?.isVerified));
            dispatch(getSelectedSearchType(parsedDraftData?.searchType));
            dispatch(setAdmissionForm(newFormValue));
            dispatch(setPLTMappedValue(parsedDraftData?.pltMappedValue));
            dispatch(setAdditionalAdmissionInfo(additionalAdmissionInfo));
            dispatch(setIsShowAdmissionForm(true));
            dispatch(setSelectedBeneficiary(selectedBeneficiaryDetail));
            dispatch(setSelectedDoctorList(parsedDraftData?.selectedDoctorList));
            dispatch(setUploadedFiles(uploadedFiles));
            dispatch(updatePackageSelection(selectedPackage));
            dispatch(updateModalFormValue(modalFormValue));
            dispatch(lockUnlockOrDeleteDraft({ draftId, isLocked: false })); // ipp-4277-removing lock status fro drafts
            dispatch(setHospitalOtherRoomType(hospitalOtherRoomType));
            dispatch(setNonAvailableClassification(nonAvailableClassification));
            dispatch(setSelectedDiscrepency(selectedDiscrepency));
            dispatch(setBuddhimedSelectedFiles(selectedFiles));
            dispatch(setClassificationArray(classificationArray));
            dispatch(setNonSelectedDiscrepency(nonSelectedDiscrepency));
            dispatch(setProbability(showProbability));
            dispatch(setIsHISClaim(isHISClaim));
            dispatch(setHisSelectedFiles(selectedHISFiles));
            dispatch(setUpdatedLetters(updatedVisibleLetters));
            dispatch(setSelectedDoctorList(selectedDoctorList));
            if (!isEmpty(modalFormValue?.fileUploadRemark)) {
              dispatch(
                updateDefaultTimeline({
                  ...getDefaultTimeline(),
                  remarks: {
                    [fileUploadRemarksKey]: modalFormValue.fileUploadRemark,
                  },
                }),
              );
            }
           if (selectedPolicyDetail) {
              dispatch(setSelectedPolicyDetail(selectedPolicyDetail));
            }
            if (panCardField) {
              dispatch(setPanField(panCardField));
            }
            if (isArtemis) {
              dispatch(setIsArtemis(isArtemis));
            }
            dispatch(setsubmitDisabled(submitDisabled));
            dispatch(setDraftFormValidated(!submitDisabled));
            dispatch(setHospitalPatientSearchDetails(hospitalSearchPatientDetails));
            dispatch(setPatientSearchDetail(selectedPatientDetail));
            dispatch(setSelectedMemberId(memberIdEntered));
            dispatch(setMemberName(newFormValue?.customerDetail?.fullName));
            dispatch(setMemberSearchId(memberSearchId));
            dispatch(setPercentageNameMatch(percentageNameMatch));
            dispatch(setGovtSchemeUrn(govtSchemeUrn));
            dispatch(setSelectedConsentOptionStyle(consentOptionStyle));
            dispatch(setPatientSignature(patientConsentProceedClicked ? patientSignature : []));
            dispatch(setPatientConsentProceedClicked(patientConsentProceedClicked));
            dispatch(setSelectedConsentOptions(patientConsentProceedClicked ? consentOption : ''));
            dispatch(setConsentDateTime(consentDateTime));
            if (patientConsentProceedClicked && consentOption === PATIENT_SIGNATURE_CONSTANTS.PATIENT_SIGNATURE_OPTIONS[1]) {
              const consentFontSize = consentOptionStyle?.fontSize;
              const consentFontFamily = consentOptionStyle?.fontFamily;
              uploadStyledSignature(fullName,
                consentFontSize, consentFontFamily);
            }
            setTimeout((): void => {
              {
                parsedDraftData?.draftKey !== 'settlement' ? !isQueryType ?
                  newAdmissionRoute() : history.push(`/claims/in-patient/detail/${base64UrlEncode(`${base64UrlEncode(payerClaimNo)}/${hospActionId}/${payerActualId}/${uniquePayerId}/${productCode}/${isCancel}/${providerDetail?.providerId}`)}/edit`) :
                  history.push(`/claims/in-patient/detail/${base64UrlEncode(`${base64UrlEncode(payerClaimNo)}/${hospActionId}/${payerActualId}/${uniquePayerId}/${productCode}/${isCancel}/${providerDetail?.providerId}`)}/edit/${base64UrlEncode(actions.CASHLESSSUMBIT)}`);
              }
            }, 10);
          } else {
            centeredNotification('Other user is currently working on this draft.');
          }
        }, 5);
      }
    } else {
      dispatch(updateSelectedDetail(record));
      const {
        payerClaimNo, hospActionId, payerId,
        productCode, providerId,
      } = record;
      const isCancel = false;
      const uniquePayerId = `${payerId}${productCode || ''}`;
      history.push(`/claims/in-patient/detail/${base64UrlEncode(`${base64UrlEncode(payerClaimNo)}/${hospActionId}/${payerId}/${uniquePayerId}/${productCode}/${isCancel}/${providerId}`)}`);
    }
  };

  const newAdmissionRoute = (): void => {
    dispatch(setCourierUpdated(false)); // clearing filters for updateCourier details bugfix-IPP-4052
    dispatch(setUpdateCourierDetailClicked(false));
    dispatch(resetBulkUploadSelectedClaims());
    dispatch(setPageIndex(1));
    dispatch(setIsSuccessModalNewAdmission(false));
    history.push('/claims/in-patient/new-admission');
    customGTMEvent({
      event: 'Click on New Admission',
    });
  };
  const initiateSettlementClickHandler = (): void => {
    clearInpatientDataAndSetLoader();
    dispatch(setIsInitiateSettelmentBtnClicked(true));
    setCheckBoxColumnInTable(0);
    dispatch(fetchInPatientList({
      getInPatientList,
    }));
    customGTMEvent({
      event: 'Clicked on Initiate Settlement in Claim View ',
    });

  };
  const InitiateSettlementCancelHandler = (): void => {
    clearInpatientDataAndSetLoader();
    dispatch(setIsInitiateSettelmentBtnClicked(false));
    dispatch(resetBulkUploadSelectedClaims());
    dispatch(fetchInPatientList({
      getInPatientList,
    }));

  };
  const blankArr = Array(10).fill(0);

  const handleTableChange = (...attributes: any): any => {
    const { columnKey: key, order: value } = attributes[2];
    const inpatientColumnsToUpdate = isPreAuthClaimViewEnabled    // setting the columns to be displayed based
      ? isPreAuthView
        ? inPatientColumnsPreAuthView
        : inPatientColumnsClaimView
      : inPatientColumns;
    const columnToUpdate = inpatientColumnsToUpdate?.find(({ key: colKey }: any): boolean => colKey === key);
    if (value !== undefined) {
      columnToUpdate.sortOrder = value;
      isPreAuthClaimViewEnabled ? isPreAuthView ? setInPatientColumnsPreAuthView([...inPatientColumnsPreAuthView]) :
        setInPatientColumnsClaimView([...inPatientColumnsClaimView]) : setInPatientColumns([...inPatientColumns]);
      dispatch(setSortingPreference(value ? { key, value: String(value)?.toUpperCase() } : null));
    }
    dispatch(searchInPatientList());
  };
  const handleTableChangeDraft = (...attributes: any): any => {
    const { columnKey: key, order: value } = attributes[2];
    const columnToUpdate = draftColumns?.find(({ key: colKey }: any): boolean => colKey === key);
    if (value !== undefined) {
      columnToUpdate.sortOrder = value;
      setDraftColumns([...draftColumns]);
      dispatch(setSortingPreference(value ? { key, value: String(value)?.toUpperCase() } : null));
    }
  };

  const onColumnEditSave = (form: FormInstance, setIsVisible: any): any => {
    const formFilterFields = form.getFieldsValue();
    const filteredFields: string[] = [];
    Object?.entries(formFilterFields)?.forEach(([key, value]: any): void => {
      if (value) {
        filteredFields?.push(key);
      }
    });
    customGTMEvent({
      event: 'Filter setting saved',
      filteredFields,
    });
    dispatch(saveInPatientConfig(form.getFieldsValue(), setIsVisible, (isPreAuthClaimViewEnabled ? (isPreAuthView ? 'preAuthView' : 'claimView') : 'inPatient')));
  };

  const handleTag = (selectedTag: any): any => {
    dispatch(setTpaGlobalSearchClicked(false));
    dispatch(setTpaGlobalSearch({ ...tpaGlobalSearch, value: '' }));
    if (isPreAuthClaimViewEnabled && !isNewTpaDeskEnabled) {
      dispatch(nextStatusAction(true));
    }
    if (groupProvidersPresent && !isNewTpaActiveForGroupProvider) {
      dispatch(nextStatusAction(true));
    }
    setIsColumnFilter(true);
    setResetSelctedTag(false);
    (isPreAuthClaimViewEnabled && isNewTpaDeskEnabled) ? handlePrimaryFilterClick() : changeNextFilterAction(selectedTag);
    if (selectedTag === 'DRAFT') {
      return draftClickHandler();
    }
    dispatch(setIsDraftBtnClicked(false));
  };

  const resetFilter = (event: any, isFromButton?: boolean): any => {
    customGTMEvent({
      event: 'Reset Search Filters',
    });
    if (isNewTpaDeskEnabled) {
      dispatch(setTPANextStatus(''));
      dispatch(setTpaDeskSecondaryFilter([]));
    }
    const updatedInPatientList = inPatientColumns
      ?.filter((ic: any): any => ic?.key !== 'selected')
      ?.map((ele: any): any => {
        ele.sortOrder = false;
        return ele;
      });
    claimForm.resetFields();
    setResetSelctedTag(true);
    dispatch(setIsDraftBtnClicked(false));
    setInPatientColumns([...updatedInPatientList]);
    searchForm.setFieldsValue({ searchValue: '' });
    if (isPreAuthClaimViewEnabled && isPreAuthView) {
      autoCompleteRef?.current?.setSearchPlaceholder(
        CLAIM_NUMBER_SEARCH_PLACEHOLDER,
      );
    } else {
      autoCompleteRef?.current?.setSearchPlaceholder(SEARCH_PLACEHOLDER);
    }
    autoCompleteRef?.current?.setFilterOptions([]);
    dispatch(setSelectedItem(''));
    dispatch(setCountClicked(true));
    if (isFromButton || !groupProvidersPresent || isNewTpaActiveForGroupProvider) {
      dispatch(clearSearchDetail());
      dispatch(setIsPreAuthView(isPreAuthView));
      dispatch(setCountClicked(true)); // to
    } else {
      dispatch(setPageIndex(1));
      dispatch(nextStatusAction(false));
      if (isFromButton === false) {
        dispatch(setCountClicked(false));
      }
    }
    if (updateCourierDetailClicked) {
      setIsTblLoading(true);
      dispatch(
        fetchInPatientList({
          getInPatientList,
        }),
      );
      dispatch(setUpdateCourierDetailClicked(false));
    }
    if (isPreAuthClaimViewEnabled && isNewTpaDeskEnabled) {
      dispatch(setIsDateChanged(true));
      setIsTblLoading(true);
    }
  };

  const resetSecondaryFilters = (event: any): any => {
    customGTMEvent({
      event: 'Reset Secondary Search Filters',
    });
    if (tpaNextStatus === TPA_BANNER_TEXT.DRAFT_PENDING) {
      draftClickHandler();
      return fetchDraftData();
    }
    dispatch(setTpaDeskSecondaryFilter([]));
    dispatch(
      fetchInPatientList({
        getInPatientList,
      }),
    );
  };

  const reloadTagCount = (prevLocation?: any): any => {
    resetInpatientListColumns();
    setIsCountLoading(true);
    dispatch(setCountClicked(true));
    if (groupProvidersPresent && prevLocation !== 'isOldLocationPresent' && !isNewTpaActiveForGroupProvider) {
      dispatch(fetchTagListCount({
        getTagListCount, getTpaTagListCount, getTagFilterCount,
      }));
    }
  };

  const resetInpatientListColumns = (): void => {
    const updatedInPatientColumns =
      inPatientColumns
        ?.filter(
          (ic: any): any =>
            ic?.key !== 'selected',
        );
    setInPatientColumns(updatedInPatientColumns);
  };

  const getTpaTagListCount = (data: any): any => {
    setIsCountLoading(false);
    setTpaTagListData(data);
  };
  const getTagFilterCount = (data: any): any => {
    setIsCountLoading(false);
    setTotalFilterCount(data);
  };

  const draftClickHandler = (): void => {
    dispatch(setIsDraftBtnClicked(true));
  };

  const getSelectedClaims = (): any => {
    return Object.keys(bulkUploadSelectedClaims || {})
      ?.filter(
        (k: any): any =>
          bulkUploadSelectedClaims[k]);
  };

  const getCheckBoxColumn = (selectedClaimCount: number): any => {
    return {
      title: <div className="circle">{selectedClaimCount}</div>,
      dataIndex: 'selected',
      key: 'selected',
      className: 'text-elipsis',
      render: (text: any, row: any): any => (
        <div onClick={selectedClickHandler}>
          <Form.Item
            name={`${row.hospActionId}_${row.payerId}_${row.productCode}`}
            valuePropName="checked"
          >
            <Checkbox />
          </Form.Item>
        </div>
      ),
    };
  };
  const getSelectedRadioColumn = (): any => {
    return {
      title: <div />,
      dataIndex: 'selected',
      key: 'selected',
      className: 'text-elipsis',
      render: (text: any, row: any): any => (
        <div onClick={selectedClickHandler}>
          <Form.Item
            name={`${row.hospActionId}_${row.payerId}_${row.productCode}`}
            valuePropName="checked"
          >
            <Radio />
          </Form.Item>
        </div>
      ),
    };
  };

  const setCheckBoxColumnInTable = (selectedClaimCount: number): void => {
    const filteredTable = getTableBasedOnConfig(
      isPreAuthClaimViewEnabled
        ? isPreAuthView
          ? appDetail.getIPPreAuthViewConfig()
          : appDetail.getIPClaimViewConfig()
        : appDetail.getIPConfig(),
      inPatientTableMapping,
    );
    const updatedColumns: any = isInitiateSettelmentBtnClicked ? [
      getCheckBoxColumn(selectedClaimCount),
      ...filteredTable,
    ] :
      [
        getSelectedRadioColumn(),
        ...filteredTable,
      ];
    isPreAuthClaimViewEnabled
      ? isPreAuthView
        ? setInPatientColumnsPreAuthView(updatedColumns)
        : setInPatientColumnsClaimView(updatedColumns)
      : setInPatientColumns(updatedColumns);
  };

  const selectedClickHandler = (e: any): any => { // to select or deselect the claims on rowClick or checkbox
    if (isInitiateSettelmentBtnClicked) {
      const { payerClaimNo, hospActionId, payerId, providerId, productCode } = e;
      const uniquePayerId = `${payerId}${productCode || ''}`;
      history.push(`/claims/in-patient/detail/${base64UrlEncode(`${base64UrlEncode(payerClaimNo)}/${hospActionId}/${payerId}/${uniquePayerId}/${productCode}/${providerId}`)}/edit/${base64UrlEncode(actions.CASHLESSSUMBIT)}`);
      dispatch(setIsInitiateSettelmentBtnClicked(false));
      return;
    }

    if (bulkUploadSelectedClaims[`${e?.hospActionId}_${e?.payerId}_${e?.productCode}`] !== true) {
      if (e.hospActionId !== undefined) {
        const selectedClaimObj = { [`${e?.hospActionId}_${e?.payerId}_${e?.productCode}`]: true };
        dispatch(setBulkUploadSelectedClaims(selectedClaimObj));
        customGTMEvent({
          event: 'Select claim to update courier details',
        });
      }
    } else {
      dispatch(deleteKeyfromBulkUploadSelectedClaims([`${e?.hospActionId}_${e?.payerId}_${e?.productCode}`]));
    }
    const selectedClaims = getSelectedClaims();
    setCheckBoxColumnInTable(selectedClaims?.length);
  };

  const callInpatientList = (): void => {
     dispatch(fetchInPatientList({
      getInPatientList,
    }));
  };
  const setSelectColumnAndFetchInitiateSettlement = (): void => {
    const selectedClaimCount =
      Object.keys(bulkUploadSelectedClaims)
        ?.filter(
          (k: any): any =>
            bulkUploadSelectedClaims[k],
        ) || [];
    dispatch(fetchInPatientList({
      getInPatientList,
    }));
    //  fetchInitiateSettlement();
    setCheckBoxColumnInTable(selectedClaimCount?.length);
  };

  const updateCourierStatusBtnClickHandler = (): void => {
    if (updateCourierDetailClicked) {
      const selectedClaims = getSelectedClaims();
      if (selectedClaims?.length > 0) {
        dispatch(fetchLookupMaster());
        setIsShowTrackCourierModal(true);
        customGTMEvent({
          event: 'Click on Enter Courier Details',
        });
      } else {
        centeredNotification('Please select at least one claim !');
      }
    } else {
      dispatch(setPageIndex(1));
      dispatch(setCourierUpdated(true));
      dispatch(setUpdateCourierDetailClicked(true));
      setSelectColumnAndFetchInitiateSettlement();
      customGTMEvent({
        event: 'Click on Update Courier Details',
      });
    }
  };

  const trackCourierFormSubmitHandler = (data: any): void => {
    const selectedClaims = getSelectedClaims();

    let courierServiceRequestDetails: any = [];
    selectedClaims?.map((formData: any): any => {
      const dataArray = formData?.split('_');
      const productCode =
        dataArray?.[2] !== 'null' &&
          dataArray?.[2] !== 'undefined'
          ? dataArray?.[2] : null;

      courierServiceRequestDetails = [
        ...courierServiceRequestDetails,
        {
          hospActionId: Number(dataArray?.[0]),
          payerId: Number(dataArray?.[1]),
          productCode,
          payerClaimExtensionFields: [
            {
              fieldName: 'courierTrackId',
              fieldValue: data?.courierReceiptNumber || data?.courierTrackId,
            },
            {
              fieldName: 'courierProvider',
              fieldValue: data?.otherCourierProvider || data?.courierProvider,
            },
          ],
        },
      ];
    });

    const payload = {
      // action: 'CASHLESSSUMBIT', removed as we are not performing settlement on courier update
      courierServiceRequestDetails,
    };
    dispatch(
      bulkUploadClaims(
        payload,
        (): void => {
          setIsShowTrackCourierModal(false);
          dispatch(resetBulkUploadSelectedClaims()); // to clear the bulkUploadSelectedClaims
          claimForm.resetFields();
          trackCourierForm.resetFields();
          dispatch(fetchInPatientList({
            getInPatientList,
          }));
        },
      ));
    customGTMEvent({
      event: 'Submit Courier Details',
    });
  };

  return (
    <>
      <PageHeader
        pageTitle={isPreAuthClaimViewEnabled ? CLAIMS_LISTING : ADMISSION_TITLE}
        titleRightButton={
          isPreAuthClaimViewEnabled && (
            <div className="inpatient-list-view-btns">
              <Popover
                placement="bottom"
                title={
                  <strong
                    className="inpatient_tooltip_header"
                  >
                    Pre Auth View
                  </strong>
                }
                content={
                  <div
                    className="inpatient_tooltip_content"
                  >
                    View Active Hospitalisation Cases.{' '}
                  </div>
                }
                trigger="hover"
              >
                <Button
                  type={isPreAuthView ? 'primary' : 'default'}
                  onClick={(): any => handleisPreAuthViewClick(true)}
                  className={`pre-auth-view-btn ${isPreAuthView ? 'selected-text' : 'unselected-text'}`}
                >
                  Pre Auth View
                </Button>
              </Popover>
              <Popover
                placement="bottom"
                title={
                  <strong
                    className="inpatient_tooltip_header"
                  >
                    Claim View
                  </strong>
                }
                content={
                  <div
                    className="inpatient_tooltip_content"
                  >
                    View Settlement Outstanding Cases.
                  </div>
                }
                trigger="hover"
              >
                <Button
                  type={!isPreAuthView ? 'primary' : 'default'}
                  onClick={(): any => handleisPreAuthViewClick(false)}
                  className={`claim-view-btn ${!isPreAuthView ? 'selected-text' : 'unselected-text'}`}
                >
                  Claim View
                </Button>
              </Popover>
            </div>
          )
        }
        rightComponent={(): ReactElement => (
          <Form form={searchForm}>
            <Row
              gutter={GUTTOR_SPACE}
              justify="end"
              className={(groupProvidersPresent && !isNewTpaActiveForGroupProvider) ? 'row-container-ip' : ''}
            >
              {groupProvidersPresent && !isNewTpaActiveForGroupProvider &&
                process.env.REACT_APP_IS_TPA_DASHBOARD_DISABLED === 'false' && (
                  <Col md={5}>
                    <Select
                      className="w-100"
                      data-testid="inpatient-filter"
                      showSearch={true}
                      placeholder="Status"
                      optionFilterProp="children"
                      defaultValue={filterAction}
                      onChange={changeAction}
                      filterOption={(input: any, option: any): any =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {INPATIENT_ACTIONS.map(
                        (actionVal: string, index: number): any => (
                          <Option
                            value={actionVal}
                            key={index}
                            data-testid={'status-' + actionVal}
                          >
                            {actionVal}
                          </Option>
                        ),
                      )}
                    </Select>
                  </Col>
                )}
              {groupProvidersPresent && !isNewTpaActiveForGroupProvider &&
                process.env.REACT_APP_IS_TPA_DASHBOARD_DISABLED === 'true' && (
                  <Col className="center-search" md={8}>
                    <Form.Item>
                      <MultiselectDropdownCheckbox
                        placeholder={'Search or Select Center'}
                        options={groupProviders}
                        value={filters['providerId']}
                        reload={reloadTagCount}
                      />
                    </Form.Item>
                  </Col>
                )}
              {groupProvidersPresent && !isNewTpaActiveForGroupProvider &&
                process.env.REACT_APP_IS_TPA_DASHBOARD_DISABLED === 'false' && (
                  <Col md={4}>
                    <FilterAutoComplete
                      setLoaderStateValue={setLoaderStateValue}
                      ref={autoCompleteRef}
                      form={searchForm}
                    />
                  </Col>
                )}
              {groupProvidersPresent && !isNewTpaActiveForGroupProvider &&
                process.env.REACT_APP_IS_TPA_DASHBOARD_DISABLED === 'false' && (
                  <Col>
                    <Tooltip title="Reset filter" mouseEnterDelay={0.25}>
                      <Button
                        data-testid="clear-filter"
                        onClick={(event: any): any => resetFilter(event, true)}
                        type={resetBtnType}
                        icon={<FilterOutlined />}
                      />
                    </Tooltip>
                  </Col>
                )}
              {groupProvidersPresent && !isNewTpaActiveForGroupProvider &&
                process.env.REACT_APP_IS_TPA_DASHBOARD_DISABLED === 'false' && (
                  <Col>
                    <TableConfigurator
                      tableMapping={filteredObjects(inPatientTableMapping, DEFAULT_TABLE_CONFIGS)}
                      saveClickHandler={onColumnEditSave}
                      configuration={
                        isPreAuthClaimViewEnabled
                          ? isPreAuthView
                            ? appDetail.getIPPreAuthViewConfig()
                            : appDetail.getIPClaimViewConfig()
                          : appDetail.getIPConfig()
                      }
                    />
                  </Col>
                )}
              {!groupProvidersPresent && !isPreAuthClaimViewEnabled &&  // displaying the ClaimCountHeader
                process.env.REACT_APP_IS_TPA_CLAIM_COUNT_FILTER === 'true' &&         // if  isPreAuthClaimViewEnabled is false
                (
                  <ClaimCountHeader
                    selectedItem={selectedItem}
                    totalClaimCount={totalClaimCount}
                    filters={filters}
                    resetFilter={resetFilter}
                  />
                )}
              {!isPreAuthClaimViewEnabled  && newAdmissionWriteAccess && (
                <Col
                  className={groupProvidersPresent ? 'courier-btn' : ''}
                >
                  <Form.Item>
                    <Button
                      className={
                        !groupProvidersPresent
                          ? updateCourierDetailClicked
                            ? 'btn-blink arrow-button'
                            : 'ghost-primary-btn arrow-button'
                          : updateCourierDetailClicked
                            ? 'btn-blink'
                            : 'ghost-primary-btn'
                      }
                      onClick={updateCourierStatusBtnClickHandler}
                      type="ghost"
                    >
                      {updateCourierDetailClicked ? `Enter` : `Update`} Courier
                      Details
                    </Button>
                  </Form.Item>
                </Col>
              )}
               { (isNewTpaDeskEnabled && isPreAuthClaimViewEnabled) &&
              <GlobalSearch handleSearchClick={handleGlobalSearchClick}/>
              }
              {isPreAuthClaimViewEnabled && isNewTpaDeskEnabled &&
                !isPreAuthView && isDownloadClaimEnabled &&
                downloadAndUploadComponent()
              }
              {!isPreAuthView && newAdmissionWriteAccess && (
                <>
                  {!updateCourierDetailBtnClicked && (
                    <Popover
                      placement="bottom"
                      content={
                        <div
                          className="inpatient_tooltip_header"
                        >
                          Update Courier Details </div>
                      }
                      trigger="hover"
                    >
                      <CourierIcon onClick={handelCourierBtn} className={`ant-alignment-margin ${(isInitiateSettelmentBtnClicked || tpaNextStatus) ? 'expired' : ''}`}
                      />
                    </Popover>
                  )}
                  {updateCourierDetailBtnClicked && (
                    <div className="inpatient-subFilters-update-courier-btn" >
                      <Button onClick={handelCourierBtn} className="courier-btn">
                        Enter Courier Details
                      </Button>
                      <Cancel_Icon onClick={handelCourierCloseBtn} className="cancel-btn" />
                    </div>
                  )}
                </>
              )}
              {newAdmissionWriteAccess &&
                isPreAuthClaimViewEnabled &&
                isPreAuthView && (
                  <Col className={groupProvidersPresent ? 'new-btn' : ''}>
                    {<Row gutter={GUTTOR_SPACE} >
                      {isPreAuthClaimViewEnabled &&
                        isDownloadClaimEnabled && isNewTpaDeskEnabled && (
                          downloadAndUploadComponent()
                        )}
                    <Form.Item>
                      <Button
                        className={`w-176 h-23  ghost-primary-btn inpatient_CTA_btn `}
                        data-testid="new-admission"
                        type={PRIMARY_BUTTON_TYPE}
                        onClick={newAdmissionRoute}
                      >
                        <span id="WA_NEW_ADMISSION">New Admission</span>
                      </Button>
                    </Form.Item>
                    </Row>}
                  </Col>
                )}

              {newAdmissionWriteAccess &&
                isPreAuthClaimViewEnabled &&
                !isPreAuthView &&
                isInitiateSettelmentBtnClicked && (
                  <Col className={groupProvidersPresent ? 'new-btn' : ''}>
                    <Form.Item>
                      <Button
                        className={
                          !groupProvidersPresent
                            ? 'ghost-primary-btn inpatient_cancel_btn '
                            : ''
                        }
                        data-testid="new-admission"
                        type="ghost"
                        onClick={InitiateSettlementCancelHandler}
                      >
                        <p>Cancel</p>
                      </Button>
                    </Form.Item>
                  </Col>
                )}

              {newAdmissionWriteAccess &&
                isPreAuthClaimViewEnabled &&
                !isPreAuthView &&
                !isInitiateSettelmentBtnClicked && (
                  <Col className={groupProvidersPresent ? 'new-btn' : ''}>
                    <Form.Item>
                      <Popover content={
                  <span
                 className="inpatient_tooltip_header"
                  >
                    Click to Initiate Settlement
                  </span>
                }>
                      <Button
                        className={
                        `h-11 w-176 ghost-primary-btn inpatient_CTA_btn`
                        }
                        data-testid="new-admission"
                        type={PRIMARY_BUTTON_TYPE}
                        onClick={initiateSettlementClickHandler}
                        disabled={updateCourierDetailClicked || disableInitiateSettlementBtn}
                      >
                        <span>Initiate Settlement</span>
                      </Button>
                      </Popover>
                    </Form.Item>
                  </Col>
                )}
              {newAdmissionWriteAccess &&
                !isPreAuthClaimViewEnabled && (
                  <Col className={groupProvidersPresent ? 'new-btn' : ''}>
                    <Form.Item>
                      <Button
                        className={
                          !groupProvidersPresent ? 'arrow-button' : ''
                        }
                        data-testid="new-admission"
                        type={PRIMARY_BUTTON_TYPE}
                        onClick={newAdmissionRoute}
                      >
                        <p id="WA_NEW_ADMISSION">New Admission</p>
                      </Button>
                    </Form.Item>
                  </Col>
                )}
            </Row>
          </Form>
        )}
      />

      <Row
        className={
          process.env.REACT_APP_IS_TPA_DASHBOARD_DISABLED === 'true'
            ? ''
            : (groupProvidersPresent && !isNewTpaActiveForGroupProvider)
              ? 'inpatient-tag-holder'
              : ''
        }
      >
        {process.env.REACT_APP_IS_TPA_DASHBOARD_DISABLED === 'true' ? (
          <TpaTaglist
            reloadTagCount={reloadTagCount}
            data={tpaTagListData}
            handleDraft={handleTag}
            resetFilter={resetFilter}
            resetSelectedTagData={resetSelectedTag}
            status={isSearchClicked}
            isRefreshLoading={isCountLoading}
            buttonType={resetBtnType}
          />
        ) : (groupProvidersPresent && !isNewTpaActiveForGroupProvider) ? (
          <TagList
            data-testid="taglist-filter"
            tagCount={inPatientTagDataCount}
            selectedTag={handleTag}
            resetTag={resetSelectedTag}
            reloadTagCount={reloadTagCount}
            isRefreshLoading={isCountLoading}
            draftCount={draftDataCount}
          />
        ) : (
          <>
            {
              (isPreAuthClaimViewEnabled && isNewTpaDeskEnabled) ?
                <div
                  className="ant-tabs-content-holder tab-custom-container" >
                  <BucketedTPA
                    resetFilter={resetFilter}
                    selectedTag={handleTag}
                    tpaTagListData={tpaTagListData}
                  />
                </div> :
                <TpaTaglist
                  reloadTagCount={reloadTagCount}
                  data={tpaTagListData}
                  handleDraft={handleTag}
                  resetFilter={resetFilter}
                  resetSelectedTagData={resetSelectedTag}
                  status={isSearchClicked}
                  isRefreshLoading={isCountLoading}
                  buttonType={resetBtnType}
                />}
          </>
        )}
      </Row>
      {searchDataVisible && !isTblLoading && (
        <>
          {isPreAuthClaimViewEnabled && isNewTpaDeskEnabled && <span className="inpatient-loaded-contents" >
            {displayViewText(isPreAuthView)} {TPA_BANNER_TEXT.SEARCH_RESULTS} (
            {isPreAuthView
              ? viewCounts?.preAuthViewClaimCount
              : viewCounts?.claimViewClaimCount}
            )
          </span>}
          <div
            className="inpatient_searched_text_div"
          >
            <p
              className="inpatient_searched_text_p"
            >
              <span className="inpatient_searched_text_p"
                dangerouslySetInnerHTML={{
                  __html: `${TPA_BANNER_TEXT.SHOWING_RESULTS} ${(tpaNextStatus && isNewTpaDeskEnabled && isPreAuthClaimViewEnabled
                  ) ? TPA_BANNER_TEXT.BASED_ON_FILTER_SELECTED : TPA_BANNER_TEXT.FOR}
              ${concatenateValues(displayFilters, allPayers, payerAllClaimStatuses, tpaGlobalSearch)}`,
                }}
              />
              {showAvailableMessages && <><span>. We have
                found </span>
                {isPreAuthView
                  ? viewCounts?.claimViewClaimCount
                  : viewCounts?.preAuthViewClaimCount}
                <span> results in </span>
                <span onClick={handleSearchNavigation} className="link_text">
                  {displayViewText(!isPreAuthView)} (
                  {isPreAuthView
                    ? viewCounts?.claimViewClaimCount
                    : viewCounts?.preAuthViewClaimCount}
                  )
                </span>
              </>}
            </p>
          </div>
        </>
      )}
      <FollowUpModal callInpatientList={callInpatientList}/>
      <div className="ant-tabs-content-holder tab-custom-container">
        <InpatientListSubFilters
          inPatientTableMapping={inPatientTableMapping}
          onColumnEditSave={onColumnEditSave}
          buttonType={resetBtnType}
          setLoaderStateValue={setLoaderStateValue}
          autoCompleteRef={autoCompleteRef}
          searchForm={searchForm}
          isRefreshLoading={isCountLoading}
          reloadTagCount={reloadTagCount}
          resetFilter={resetFilter}
          secondaryFilterData={tpaTagListData?.[tpaNextStatus]?.secondClaimCountDetails || {}}
          totalSecondClaimCountData = {totalFilterCount || {}}
          isCountClickedData = {isCountClicked}
          handleSecondaryFilter={handleTag}
          availableTpaSecondaryFilter={showSelectedTpaSecondaryFilters}
          resetSecondaryFilters={resetSecondaryFilters}
          getScrollContainer={getScrollContainer}
          inPatientCasesDataCount={inPatientCasesDataCount}
       />
        <Form form={claimForm}>
        <div ref={tableRef}>
          <Table
            data-testid="in-patient-list"
            className="inPatientTable"
            size={TABLE_SIZE_MIDDLE}
            scroll={(isPreAuthClaimViewEnabled && isNewTpaDeskEnabled) ? { x: 'max-content'} : {}}
            columns={
              isDraftBtnClicked ? draftColumns // setting the table columns based on the view selected or draft
                : isPreAuthClaimViewEnabled ? isPreAuthView ? inPatientColumnsPreAuthView
                  : inPatientColumnsClaimView : inPatientColumns
            }
            dataSource={isDraftBtnClicked ? draftData : inPatientData}
            pagination={false}
            onRow={(record: any, rowIndex: any): any => {
              return {
                onClick: (event: any, e: any): any => {
                  !updateCourierDetailClicked &&
                    !isInitiateSettelmentBtnClicked ?
                    rowClick(event, record, rowIndex) : selectedClickHandler(record);
                },
              };
            }}
            locale={{
              emptyText: isTblLoading ? (
                <div className="full-skelton-in-list">
                  {blankArr.map((...params: any[]): any => (
                    <Skeleton
                      key={params[1]}
                      active={true}
                      paragraph={{ rows: 0 }}
                    />
                  ))}
                </div>
              ) : (
                isPreAuthClaimViewEnabled ? <InpatientNoData /> : <Empty />
              ),
            }}
            onChange={
              isDraftBtnClicked ? handleTableChangeDraft : handleTableChange
            }
          />
          </div>
        </Form>
        {(inPatientDataCount > 0 || draftDataCount > 0) && <Pagination
          data-testid="pagination"
          showSizeChanger={false}
          onChange={pageChange}
          defaultCurrent={1}
          current={pageIndex}
          total={isDraftBtnClicked ? draftDataCount : inPatientDataCount}
          className="mt-md text-center"
        />}

        <TrackCourierModal
          isShowTrackCourierModal={isShowTrackCourierModal}
          setIsShowTrackCourierModal={setIsShowTrackCourierModal}
          trackCourierForm={trackCourierForm}
          trackCourierFormSubmitHandler={trackCourierFormSubmitHandler}
        />
      </div>
    </>
  );
};

export default List;
